<mat-dialog-content style="display: flex; flex-direction: column;">

    <h2 mat-dialog-title style="margin: 0px;">Kunden Account anlegen</h2>

    <div style="display: flex;">
        <mat-form-field style="flex-grow: 1">
            <input type="text" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" matInput
                placeholder="Benutzername" [(ngModel)]="name">
        </mat-form-field>
    </div>
    <div style="display: flex;">
        <mat-form-field style="flex-grow: 1">
            <input type="text" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" matInput
                placeholder="Email" [(ngModel)]="email">
        </mat-form-field>
    </div>
    <div style="display: flex; margin-bottom: 10px;">
        <mat-form-field style="flex-grow: 1">
            <input type="text" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" matInput
                placeholder="Passwort" [(ngModel)]="password">
        </mat-form-field>
    </div>
    <div style="display: flex; flex-direction: column; margin-bottom: 10px;">
        <div style="display: flex;">
            <strong>Account Typ</strong>
        </div>
        <div style="display: flex;">

            <mat-radio-group class="example-radio-group" [(ngModel)]="accountType">
                <mat-radio-button value="modular" style="width: 100%">
                    Modular
                </mat-radio-button>
                <mat-radio-button value="kul" style="width: 100%">
                    KuL Komplettpaket
                </mat-radio-button>
                <mat-radio-button value="kulm" style="width: 100%">
                    KuL Komplettpaket + Mechanik
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </div>

    <ng-container *ngIf="accountType ==='modular'">
        <strong>Module</strong>
        <div style="display: flex;">
            <mat-checkbox class="full-width" [(ngModel)]="dellen">Dellentechnik
            </mat-checkbox>
        </div>
        <div style="display: flex;">
            <mat-checkbox class="full-width" [(ngModel)]="multiUser">Mehrbenutzerversion
            </mat-checkbox>
        </div>
        <div style="display: flex;">
            <mat-checkbox class="full-width" [(ngModel)]="planer">Planung
            </mat-checkbox>
        </div>
        <div style="display: flex;">
            <mat-checkbox class="full-width" [(ngModel)]="mietwagen">Mietwagen
            </mat-checkbox>
        </div>
        <div style="display: flex; margin-bottom: 10px;">
            <mat-checkbox class="full-width" [(ngModel)]="win">Desktop Tools
            </mat-checkbox>
        </div>
    </ng-container>

    <div>
        <button mat-button (click)="selectCopyKunde()" *ngIf="!copyAccountId">Konfiguration kopieren</button>
        <ng-container *ngIf="copyAccountId">
            {{copyAccountName}}&nbsp;<mat-icon style="cursor: pointer;" (click)="clearCopyKunde()">close</mat-icon>
        </ng-container>
    </div>


    <ng-container *ngIf="accountType === 'kul' || accountType === 'kulm'">

        <div style="display: flex;">
            <mat-checkbox class="full-width" [(ngModel)]="audatex">Audatex wurde bestellt
            </mat-checkbox>
        </div>

        <div style="display: flex;">
            <mat-checkbox class="full-width" [(ngModel)]="audatexUntilActive">Audatex Test
            </mat-checkbox>
        </div>

        <div style="display: flex;" *ngIf="audatexUntilActive">
            <mat-form-field>
                <input matInput [matDatepicker]="audatexUntilDatePicker" placeholder="Testversion Audatex bis" [(ngModel)]="audatexUntilDate"
                    [disabled]="!test">
                <mat-datepicker-toggle matSuffix [for]="audatexUntilDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #audatexUntilDatePicker [disabled]="!audatexUntilActive"></mat-datepicker>
            </mat-form-field>
        </div>
    </ng-container>

    <div style="display: flex;">
        <mat-checkbox class="full-width" [(ngModel)]="test">Testversion
        </mat-checkbox>
    </div>
    <div style="display: flex;">
        <mat-form-field>
            <input matInput [matDatepicker]="testDatePicker" placeholder="Testversion bis" [(ngModel)]="testBis"
                [disabled]="!test">
            <mat-datepicker-toggle matSuffix [for]="testDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #testDatePicker [disabled]="!test"></mat-datepicker>
        </mat-form-field>
    </div>
    <mat-dialog-actions>
        <button mat-button color="warn" mat-dialog-close tabindex="-1">Abbrechen</button>
        <button mat-button color="accent" (click)="createPdrAccount()"
            [disabled]="!name || !email || !password || !accountType">Account anlegen</button>
    </mat-dialog-actions>